<svg width="20" height="20" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
  <path
    d="M2 9V8C2 8 4.38983 7 6 7C7.61017 7 9 8 10 8C11 8 12.3898 7 14 7C15.6102 7 18 8 18 8V9H17C17 9 16.5 13 14 13C10.5 13 10.5 10 10.5 10C10.5 10 10.5 9.5 10 9.5C9.5 9.5 9.5 10 9.5 10C9.5 10 9.2352 13 6 13C3 13 3 9 3 9H2Z"
  />
</svg>
